import { Wallet, TrendingDown, PiggyBank, Gauge } from "lucide-react";
import { fmtTL, fmtNum } from "../../lib/format";
import { lrSummary, usageTone, usageBar } from "./limitRiskConst";

// Toplam Limit · Toplam Risk · Kalan Limit · Doluluk % (filtrelenmiş kartlar üzerinden) + nakdi / gayrinakdi dağılım çipleri
export default function LimitRiskSummary({ rows }) {
  const s = lrSummary(rows);
  const boxes = [
    { key: "limit", label: "Toplam Limit", value: fmtTL(s.limit), icon: Wallet, sub: `${s.banks} firma/banka kartı` },
    { key: "risk", label: "Toplam Risk", value: fmtTL(s.risk), icon: TrendingDown, sub: "kullanılan" },
    { key: "remaining", label: "Kalan Limit", value: fmtTL(s.remaining), icon: PiggyBank, sub: s.remaining < 0 ? "limit aşımı!" : "kullanılabilir", tone: s.remaining < 0 ? "text-red-700" : "" },
    { key: "pct", label: "Doluluk", value: s.pct == null ? "—" : `%${fmtNum(s.pct, 1)}`, icon: Gauge, tone: usageTone(s.pct), bar: s.pct },
  ];
  const chips = [["nakdi", "Nakdi", s.nakdiLimit, s.nakdiRisk], ["gayrinakdi", "Gayrinakdi", s.gayriLimit, s.gayriRisk]];
  return (
    <div className="space-y-2" data-testid="lr-summary">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {boxes.map((b) => (
          <div key={b.key} className="kpi" data-testid={`lr-sum-${b.key}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{b.label}</div>
                <div className={`mt-1.5 text-lg font-bold font-mono tracking-tight ${b.tone || "text-slate-900"}`}>{b.value}</div>
                {b.sub && <div className="text-[10px] text-slate-500">{b.sub}</div>}
              </div>
              <b.icon className="w-4 h-4 text-amber-600 shrink-0" />
            </div>
            {b.bar != null && <div className="mt-2 h-1.5 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full ${usageBar(b.bar)}`} style={{ width: `${Math.min(b.bar, 100)}%` }} /></div>}
          </div>
        ))}
      </div>
      {rows.length > 0 && (
        <div className="flex flex-wrap items-center gap-1.5" data-testid="lr-type-summary">
          <span className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Türe göre:</span>
          {chips.map(([k, label, l, r]) => <span key={k} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border border-slate-300 bg-white text-slate-800" data-testid={`lr-type-sum-${k}`}>{label} <span className="text-slate-500">limit</span> <b className="font-mono">{fmtTL(l)}</b> <span className="text-slate-500">risk</span> <b className="font-mono">{fmtTL(r)}</b></span>)}
        </div>
      )}
    </div>
  );
}
